import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://97ac43440dd10b71f5c1394e03df4725@o683795.ingest.us.sentry.io/4509346020261888",

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  integrations: [Sentry.replayIntegration()],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // tracesSampleRate: 1.0,
  // // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: [
  //   "localhost",
  //   /^https:\/\/nicolethemathlady\.com\/api\//,
  // ],
});
